import React, { Component } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert";

import { addValue, createForm, getDirections } from "../actions";

import LoadingDots from "./ui/LoadingDots";
import { CompanyInfo } from "./program/CompanyInfo";

class RequestCreate extends Component {
	modal;

	state = {
		selectedDirection: null,
	};

	componentDidMount() {
		this.props.getDirections();
	}

	onSelect = (state, value) => {
		const toSet = {};
		toSet[state] = value || null;
		this.setState(toSet);
	};

	onCreate = () => {
		if (!this.props.directions?.length) {
			confirmAlert({
				message: "В данный момент отсутствуют потоки FastTrack, доступные для подачи заявки",
				buttons: [{ label: "Ок" }],
			});
			return;
		}
		this.props.createForm(this.state);
	};

	render() {
		const { selectedDirection } = this.state;
		const { companies, loaders, directions } = this.props;

		return (
			<LoadingDots show={typeof loaders.companies !== "undefined" || !this.props.modeLoaded}>
				{companies.length > 0 && (
					<div className="text-block">
						<div className="from-group">
							<div className="row">
								<div className="col-sm-5 col-xs-12">
									<label>Выберите направление</label>
									<Select
										autosize={false}
										name="form-field-name"
										placeholder="Выберите из списка"
										value={this.state.selectedDirection}
										style={{ borderColor: "#ccc" }} // : "#4eb43e"
										noResultsText="Список пуст"
										onChange={(value) => this.onSelect("selectedDirection", value)}
										options={directions.map((directions) => ({
											...directions,
											label: directions.direction_name,
											value: directions.id,
										}))}
									/>
								</div>
								<div className="col-sm-3 col-xs-12">
									<label>&nbsp;</label>
									<button
										type="button"
										className="btn btn-success btn-sm w-btn"
										onClick={this.onCreate}
										disabled={!selectedDirection}
									>
										Создать заявку
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
				{companies.length === 0 && <div className="text-block text-block_empty">Не найдено ни одной компании</div>}
				<CompanyInfo
					ref={(modal) => {
						this.modal = modal;
					}}
					programUid={0}
					onSend={this.onCreateEntity}
				/>
			</LoadingDots>
		);
	}
}

RequestCreate.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	companies: PropTypes.array.isRequired,
	loaders: PropTypes.shape({}).isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	forms: PropTypes.array.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	directions: PropTypes.array,
	user: PropTypes.shape({}).isRequired,
	createForm: PropTypes.func.isRequired,
	getDirections: PropTypes.func.isRequired,
};

RequestCreate.defaultProps = {
	directions: [],
};

const mapDispatchToProps = {
	createForm,
	addValue,
	getDirections,
};

const mapStateToProps = (state) => ({
	companies: state.forms.companies,
	loaders: state.forms.loaders,
	forms: state.forms.forms,
	modeLoaded: state.forms.modeLoaded,
	flows: state.forms.flows,
	directions: state.forms.directions,
	user: state.forms.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestCreate);
